import gql from 'graphql-tag';

export const GET_TEMPLATE_BY_ID = gql`
  query GetTemplateById($id: ID!) {
    bpf {
      template(id: $id) {
        name
        isActive
        createdDateTime
        modifiedDateTime
        businessProcessFlowId
        applyRules {
          paymentType
        }
        department {
          id
          name
        }
        stages {
          name
          ordinal
          stageFields
          completionRules
          businessProcessFlowId
          businessProcessFlowStageId
        }
      }
    }
  }
`;
